export default "__VITE_ASSET__2880686e__"